/**
 * Signed-in customers land on Dashboard. Home in the nav still opens the
 * public homepage with ?home=1 so they can come back without losing login.
 */

export const PUBLIC_HOME_PARAM = 'home';
export const PUBLIC_HOME_VALUE = '1';
export const publicHomeSearch = `?${PUBLIC_HOME_PARAM}=${PUBLIC_HOME_VALUE}`;
export const publicHomeTo = { search: publicHomeSearch };

/**
 * True when this search string asked for the public homepage.
 *
 * @param {string} [search]
 * @returns {boolean}
 */
export const isPublicHomeView = search => {
  if (typeof search !== 'string' || !search) {
    return false;
  }
  const raw = search.charAt(0) === '?' ? search.slice(1) : search;
  // Promo links (?promo=sweettreat) still go to the dashboard, where the Sweet Treat pop-up opens.
  return new URLSearchParams(raw).get(PUBLIC_HOME_PARAM) === PUBLIC_HOME_VALUE;
};

/**
 * Search for the signed-in redirect off `/`: the destination's own search plus any
 * promo/src from the visited URL, so the dashboard still knows the visitor came from a promo.
 *
 * @param {string} [destSearch]
 * @param {string} [locationSearch]
 * @returns {string|undefined}
 */
export const redirectSearchWithPromo = (destSearch, locationSearch) => {
  const from = new URLSearchParams((locationSearch || '').replace(/^\?/, ''));
  const out = new URLSearchParams((destSearch || '').replace(/^\?/, ''));
  ['promo', 'src'].forEach(k => {
    const v = (from.get(k) || '').trim();
    if (v && !out.get(k)) out.set(k, v.slice(0, 40));
  });
  const str = out.toString();
  return str ? `?${str}` : destSearch || undefined;
};

/**
 * NamedLink `to` for Home. Guests stay on `/`. Signed-in users keep `?home=1`.
 *
 * @param {Object} [params]
 * @param {boolean} [params.isAuthenticated]
 * @returns {{ search: string }|undefined}
 */
export const landingPageLinkTo = ({ isAuthenticated } = {}) =>
  isAuthenticated ? publicHomeTo : undefined;
